import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

const ENGINE_OIL_RESERVOIR_TOP_OFFSET = 46;
const ENGINE_OIL_RESERVOIR_LEFT_OFFSET = 179;

export interface EngineOilReservoirProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function EngineOilReservoir(props: EngineOilReservoirProps) {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute cursor-pointer group"
      style={{top: ENGINE_OIL_RESERVOIR_TOP_OFFSET, left: ENGINE_OIL_RESERVOIR_LEFT_OFFSET}}
      onClick={props.onClick}
      aria-labelledby="engine-oil-reservoir-title"
    >
      <title id="engine-oil-reservoir-title">Engine Oil Reservoir</title>
      <path
        d="M5 1H17C21 1 21 5 21 5V11C21 11 21 15 17 15H5C1 15 1 11 1 11L1 5C1 5 1 1 5 1Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}), '[pointer-events:none]')}
      />
      <path
        d="M5 1.00001H17C21 1.00001 21 5.00001 21 5.00001V11C21 11 21 15 17 15H5C1 15 1 11 1 11L1 5.00001C1 5.00001 1 1.00001 5 1.00001Z"
        stroke="currentColor"
        className={cn(partStroke({variant: props.variant}), '[pointer-events:none]')}
        strokeWidth="2"
      />
    </svg>
  );
}
